// removed by extract-text-webpack-plugin
module.exports = {"btn-apex-primary":"_3H1UYEd-7TNYG_r7XUtGKU","focus":"_3La9-3Pv6udp-FRnfkikjh","active":"oyFvN7rkKfGMn3s3IJyCK","disabled":"_10d5O4_QD6jX9yuJ2IL8M6","badge":"_5W32bwAdTMawrjJik_D9O","btn-apex-secondary":"_2VC8b98ItNPP4T3chCoLj-","btn-apex-secondary-no-hover":"uMm5-5D30kY7EDNPOhFvj","btn-apex-negative":"BQIF6lwp7pFC_JQOLVSMp","btn-apex-orange":"_1U50DmXDeCLWhbb5wINe03","title":"_1FWVq-FO3Rmu_m4FhN3ooB"};


//////////////////
// WEBPACK FOOTER
// ./src/components/LongDetailsPanel/styles.css
// module id = 3150
// module chunks = 0